(function () {
    function getParam(p) {
        const match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    function getExpiryRecord(value, expireInDays = 7) {
        const expiryPeriod = expireInDays * 24 * 60 * 60 * 1000; // Days to milliseconds
        const expiryDate = new Date().getTime() + expiryPeriod;
        return {
            value: value,
            expiryDate: expiryDate
        };
    }

    function getHostnameFromReferrer() {
        const referrer = document.referrer;
        if (referrer) {
            try {
                const url = new URL(referrer);
                // Check if referrer is external, then return
                return window.location.hostname !== url.hostname ? url.hostname : null;
            } catch (error) {
                return null;
            }
        } else {
            return null;
        }
    }

    function addParam(paramName, useStorage, fieldSelector = '', expireInDays = 7, isValidCallback, fallbackValue) {
        let isValidToStore = true,
            record = null,
            param = getParam(paramName);

        if (!param && typeof fallbackValue === "function") {
            param = fallbackValue();
        }

        if (typeof isValidCallback === "function") {
            isValidToStore = isValidCallback();
        }

        if (param && isValidToStore) {
            record = getExpiryRecord(param, expireInDays);
            useStorage.setItem('hofmannApiTracking::' + paramName, JSON.stringify(record));
        }

        const item = record || JSON.parse(useStorage.getItem('hofmannApiTracking::' + paramName));
        const isValid = item && new Date().getTime() < item.expiryDate;

        if (isValid) {
            document.querySelectorAll(fieldSelector).forEach(element => {
                if (element instanceof HTMLInputElement) {
                    element.value = item.value;
                }
            });
        }
    }

    window.addEventListener('load', function(){
        // Google click id
        addParam('gclid', localStorage, 'input[type="hidden"].gclid, input[type="hidden"]#gclid, input[type="hidden"][name="gclid"]', 90, function(){
            // Validation param if available
            const gclsrcParam = getParam('gclsrc');
            return !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;
        });

        // jobboard param to origin
        addParam('jobboard', sessionStorage, 'input[type="hidden"][data-cv-bind][name="data[origin]"]', 1, null, function(){
            // referrer as fallback value of jobboard is empty
            return getHostnameFromReferrer();
        })
    });

})();